module.exports = __webpack_public_path__ + "6f01192aea48208b462cc4790e8d8b2a.png";